import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
    {
      path: '/live-ticker',
      name: 'Live Ticker',
      component: () => import(/* webpackChunkName: "about" */ '../views/Pricelist.vue')
    },
    {
      path: '/production',
      name: 'Production Tree',
      component: () => import(/* webpackChunkName: "about" */ '../views/Production.vue')
    },
  {
    path: '/',
    name: 'Price History',
    component: Home
  },
  {
    path: '/company',
    name: 'Company',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Company.vue')
  },

    {
      path: '/level',
      name: 'Level',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../views/Level.vue')
    }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
